var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeurons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.913 3.9561C15.7511 3.7071 15.4169 3.63617 15.1683 3.79883L13.5357 4.86126L11.0942 3.45226C10.9276 3.35609 10.7227 3.35609 10.5562 3.45226L8.09787 4.87109L5.90871 3.6075V1.45135C5.90871 1.15426 5.668 0.91333 5.37065 0.91333C5.07316 0.91333 4.83249 1.15429 4.83249 1.45135V3.60747L2.66962 4.85578L0.844628 3.59167C0.600761 3.42277 0.265002 3.48374 0.0957179 3.72777C-0.0734352 3.97216 -0.0124682 4.30714 0.231824 4.47668L2.10528 5.77433V8.64174C2.10528 8.83398 2.20768 9.01165 2.37429 9.10782L4.83246 10.5269V12.5485C4.83246 12.8456 5.07316 13.0865 5.37062 13.0865C5.66794 13.0865 5.90867 12.8456 5.90867 12.5485V10.5269L8.09783 9.26307L10.2871 10.5269V12.5485C10.2871 12.8456 10.5277 13.0865 10.8252 13.0865C11.1226 13.0865 11.3633 12.8456 11.3633 12.5485V10.5269L13.8215 9.10782C13.9881 9.01165 14.0905 8.83395 14.0905 8.64174V5.78403L15.7553 4.70053C16.0045 4.5384 16.0749 4.20522 15.913 3.9561ZM3.18152 5.80329L5.37068 4.53971L7.55984 5.80329V8.33086L5.37068 9.59471L3.18152 8.33086V5.80329ZM13.0144 8.33086L10.8252 9.59471L8.63605 8.33086V5.80329L10.8252 4.53971L13.0144 5.80329V8.33086Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurons);
export default __webpack_public_path__ + "static/media/neurons.1b4ac07caa50a32b34d66ffc4a006162.svg";
export { ForwardRef as ReactComponent };